import { API_BASE_URL } from './api';

export interface ChatMessage {
  conversationId: string;
  messageId: string;
  role: 'user' | 'assistant';
  content: string;
  createdAt: string;
  inputTokens?: number;
  outputTokens?: number;
  cacheHit: boolean;
}

export interface ChatConversation {
  userId: string;
  conversationId: string;
  title: string;
  createdAt: string;
  updatedAt: string;
  messageCount: number;
}

export interface SendMessageResponse {
  conversationId: string;
  userMessage: ChatMessage;
  aiMessage: ChatMessage;
}

export interface ChatHistoryResponse {
  conversation: ChatConversation | null;
  messages: ChatMessage[];
}

const authHeader = (token: string) => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token}`,
});

export const chatService = {
  sendMessage: async (
    token: string,
    message: string,
    conversationId?: string
  ): Promise<SendMessageResponse> => {
    const res = await fetch(`${API_BASE_URL}/chat/message`, {
      method: 'POST',
      headers: authHeader(token),
      body: JSON.stringify({ conversationId: conversationId ?? '', message }),
    });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || 'Failed to send message');
    }
    return res.json();
  },

  getHistory: async (token: string, conversationId: string): Promise<ChatHistoryResponse> => {
    const res = await fetch(`${API_BASE_URL}/chat/history/${conversationId}`, {
      headers: authHeader(token),
    });
    if (!res.ok) throw new Error('Failed to load conversation history');
    return res.json();
  },

  getConversations: async (token: string): Promise<ChatConversation[]> => {
    const res = await fetch(`${API_BASE_URL}/chat/conversations`, {
      headers: authHeader(token),
    });
    if (!res.ok) throw new Error('Failed to load conversations');
    return res.json();
  },
};
